module.exports = __webpack_public_path__ + "static/media/William McKinley - 1900.4cf9ddb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/William McKinley - 1900.jpg
// module id = 575
// module chunks = 0